export default function() {
  return [
    {
      title: 'Dashboard',
      to: {
        name: 'dashboard'
      },
      htmlBefore: '<i class="material-icons">edit</i>',
      htmlAfter: ''
    },
    {
      title: 'Klienci',
      htmlBefore: '<i class="material-icons">person</i>',
      to: {
        name: 'clients-list'
      }
    },
    {
      title: 'Komornicy',
      htmlBefore: '<i class="material-icons">people</i>',
      to: {
        name: 'bailiffs-list'
      }
    },
    {
      title: 'Spółki',
      htmlBefore: '<i class="material-icons">domain</i>',
      to: {
        name: 'companies-list'
      }
    },
    {
      title: 'Umowy',
      htmlBefore: '<i class="material-icons">table_chart</i>',
      to: {
        name: 'schedules-list'
      }
    },
    {
      title: 'Umowy wewnętrzne',
      htmlBefore: '<i class="material-icons">table_chart</i>',
      to: {
        name: 'schedules-list-internal'
      }
    },
    {
      title: 'Sprawy w egzekucji',
      htmlBefore: '<i class="material-icons">approval</i>',
      to: {
        name: 'executions-list'
      }
    },
    {
      title: 'Wydatki',
      htmlBefore: '<i class="material-icons">euro</i>',
      to: {
        name: 'expenses-list'
      }
    },
    {
      title: 'Sądy',
      htmlBefore: '<i class="material-icons">account_balance</i>',
      to: {
        name: 'courts-list'
      }
    },
    {
      title: 'Faktury',
      htmlBefore: '<i class="material-icons">file_copy</i>',
      to: {
        name: 'invoices-list'
      }
    },
    {
      title: 'Raporty',
      htmlBefore: '<i class="material-icons">bar_chart</i>',
      to: {
        name: 'raports'
      }
    },
    {
      title: 'Słowniki',
      htmlBefore: '<i class="material-icons">library_books</i>',
      to: {
        name: 'dictionary'
      }
    },
    {
      title: 'Święta',
      htmlBefore: '<i class="material-icons">emoji_transportation</i>',
      to: {
        name: 'holidays'
      }
    }
  ];
}
